module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-ring-3-23e2279dbe76d7afdd5625ded652ff1c.svg";